import styled from 'styled-components';

export const Container = styled.section`
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 48px;
  padding: 0 5%;

  @media ${({ theme }) => theme.devices.tablet} {
    display: flex;
  }
`;

export const Collumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

export const InfosNav = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;

  a {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-transform: uppercase;
    text-align: center;
    padding: 8px 2px;
    border-radius: 16px;
    background-color: #262727;

    img {
      width: 100%;
      max-width: 28px;
    }

    span {
      font-size: 10px;
    }

    &:hover {
      transition: 0.7s;
      opacity: 0.7;
    }
  }
`;

export const PrinceInfos = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-top: 12px;

  h1 {
    margin-top: 4px;
    font-family: 'Bebas Neue', sans-serif;
    font-size: 40px;
    font-weight: 700;
    word-spacing: -4px;
  }

  button {
    position: relative;
    top: -4px;
    left: 8px;
    background: transparent;
    border: 0;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.grey.white};
    text-transform: uppercase;
    text-decoration: underline;
    padding: 4px 8px;

    &:hover {
      transition: 0.7s;
      color: ${({ theme }) => theme.colors.grey[200]};
    }
  }
`;

export const PhoneInfos = styled.div`
  width: fit-content;

  a {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    padding: 6px 20px 6px 8px;
    border-radius: 64px;
    background-color: ${({ theme }) => theme.colors.grey.white};
    color: ${({ theme }) => theme.colors.grey.black};

    img {
      width: 64px;
      height: 64px;
    }

    h1 {
      letter-spacing: -1px !important;
      font-size: 28px;
      font-weight: 700;
    }

    .col {
      display: flex;
      flex-direction: column;

      span {
        font-weight: 700;
        font-size: 12px;
      }
    }

    &:hover {
      transition: 0.7s;
      opacity: 0.8;
    }
  }
`;

export const UlValues = styled.ul`
  width: 100%;
  display: ${({ $show }) => ($show ? 'flex' : 'none')};
  flex-direction: column;
  list-style: none;
  margin-top: 8px;
  border-radius: 0 0 8px 8px;
  border-top: 3px solid ${({ theme }) => theme.colors.primary.dark};
  overflow: hidden;

  li {
    display: flex;
    padding: 12px 8px;
    background-color: ${({ theme }) => theme.colors.grey[600]};

    &:nth-child(2n + 1) {
      background-color: ${({ theme }) => theme.colors.grey[700]};
    }

    span {
      margin-bottom: -4px;
    }
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.grey[500]};

  > span {
    display: flex;
    flex-direction: column;
  }
`;
